import { put } from 'redux-saga/effects';

import { api as analyticsApi } from '../utils/analyticsApi';

export function sendEventSagaFactory(actions) {
  return function* ({ payload }) {
    try {
      yield analyticsApi.post('/event', payload);
      yield put(actions.sendEventSuccess());
    } catch (error) {
      yield put(actions.sendEventError(error.message));
    }
  };
}
